import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { getSpacing } from 'stylesheet';

export const Wrapper = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${getSpacing(8)} 0;
`;

export const Line = styled.div<{ focused: boolean }>`
  height: 2px;
  background-color: ${props =>
    props.focused ? defaultTheme.colors.darkBlue : defaultTheme.colors.separator};
  width: 50%;
`;

export const Point = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
`;
